var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('chart-line',{attrs:{"height":210,"data":_vm.lineChartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }